import { LOAD_CHART_WIDGET_DATA_REQUEST } from './widgetsSagas/chart/actionTypes';

export const GET_DASHBOARD_INFO_REQUEST = '[DASHBOARD] GET_DASHBOARD_INFO_REQUEST';
export const GET_DASHBOARD_INFO_SUCCESS = '[DASHBOARD] GET_DASHBOARD_INFO_SUCCESS';
export const GET_DASHBOARD_INFO_FAILED = '[DASHBOARD] GET_DASHBOARD_INFO_FAILED';

export const CLEAN_LAYOUT = '[DASHBOARD] CLEAN_LAYOUT';

export const UPDATE_LAYOUT = "[DASHBOARD] UPDATE_LAYOUT";

export const CHANGE_EDIT_STATE = "[DASHBOARD] CHANGE_EDIT_STATE";

export const UPDATE_REAL_TIME_INTERFACES_DATA_REQUEST = "[DASHBOARD] UPDATE_REAL_TIME_INTERFACES_DATA_REQUEST";
export const UPDATE_REAL_TIME_INTERFACES_DATA_SUCCESS = "[DASHBOARD] UPDATE_REAL_TIME_INTERFACES_DATA_SUCCESS";
export const UPDATE_REAL_TIME_INTERFACES_DATA_FAILED = "[DASHBOARD] UPDATE_REAL_TIME_INTERFACES_DATA_FAILED";

export const CREATE_WIDGET_REQUEST = "[DASHBOARD] CREATE_WIDGET_REQUEST";
export const CREATE_WIDGET_SUCCESS = "[DASHBOARD] CREATE_WIDGET_SUCCESS";
export const CREATE_WIDGET_FAILED = "[DASHBOARD] CREATE_WIDGET_FAILED";

export const EDIT_WIDGET_REQUEST = "[DASHBOARD] EDIT_WIDGET_REQUEST";
export const EDIT_WIDGET_SUCCESS = "[DASHBOARD] EDIT_WIDGET_SUCCESS";
export const EDIT_WIDGET_FAILED = "[DASHBOARD] EDIT_WIDGET_FAILED";

export const DELETE_WIDGET_REQUEST = "[DASHBOARD] DELETE_WIDGET_REQUEST";
export const DELETE_WIDGET_SUCCESS = "[DASHBOARD] DELETE_WIDGET_SUCCESS";
export const DELETE_WIDGET_FAILED = "[DASHBOARD] DELETE_WIDGET_FAILED";

export const DUPLICATE_WIDGET_REQUEST = "[DASHBOARD] DUPLICATE_WIDGET_REQUEST";
export const DUPLICATE_WIDGET_SUCCESS = "[DASHBOARD] DUPLICATE_WIDGET_SUCCESS";
export const DUPLICATE_WIDGET_FAILED = "[DASHBOARD] DUPLICATE_WIDGET_FAILED";

export const GET_DASHBOARD_DASHBOARD_ENTITIES_TREE_REQUEST = '[DASHBOARD] GET_DASHBOARD_DASHBOARD_ENTITIES_TREE_REQUEST';
export const GET_DASHBOARD_DASHBOARD_ENTITIES_TREE_SUCCESS = '[DASHBOARD] GET_DASHBOARD_DASHBOARD_ENTITIES_TREE_SUCCESS';
export const GET_DASHBOARD_DASHBOARD_ENTITIES_TREE_FAILED = '[DASHBOARD] GET_DASHBOARD_DASHBOARD_ENTITIES_TREE_FAILED';

export const LOAD_WIDGET_DATA_REQUEST = '[DASHBOARD] LOAD_WIDGET_DATA_REQUEST';
export const LOAD_WIDGET_DATA_SUCCESS = '[DASHBOARD] LOAD_WIDGET_DATA_SUCCESS';
export const LOAD_WIDGET_DATA_FAILED = '[DASHBOARD] LOAD_WIDGET_DATA_FAILED';

export {
    LOAD_CHART_WIDGET_DATA_REQUEST
};